export const appRoutes = {
  startRoute: {
    pathname: '/start',
    isOneLayout: true,
  },
}
